import { render, staticRenderFns } from "./ClientsFilter.vue?vue&type=template&id=fb04e6ec&scoped=true&"
import script from "./ClientsFilter.vue?vue&type=script&lang=js&"
export * from "./ClientsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClientsFilter.vue?vue&type=style&index=0&id=fb04e6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb04e6ec",
  null
  
)

export default component.exports